// Analytics helper — envía eventos a PostHog (ya instalado en public/index.html)
// y a Google Analytics (gtag) si está presente en la página.
//
// Respeta consentimiento: si el usuario ha rechazado analíticas en el banner
// de cookies (fm_cookie_consent), NO enviamos nada. Así cumplimos la política
// que ya declaramos en /politica-cookies.

const CONSENT_KEY = "fm_cookie_consent";

function hasAnalyticsConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const p = JSON.parse(raw);
    return !!p?.analiticas;
  } catch {
    return false;
  }
}

/**
 * Dispara un evento de conversión.
 *
 * @param {string} eventName snake_case, ej: "cta_informe_premium_click"
 * @param {object} props propiedades adicionales (source, subasta_id, path…)
 */
export function trackEvent(eventName, props = {}) {
  if (!eventName) return;
  if (!hasAnalyticsConsent()) return;

  const payload = {
    path: typeof window !== "undefined" ? window.location.pathname : "",
    ...props,
  };

  try {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(eventName, payload);
    }
  } catch { /* noop */ }

  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
    }
  } catch { /* noop */ }
}

// Constantes de eventos para evitar typos.
export const EVENTS = {
  CTA_INFORME_PREMIUM: "cta_informe_premium_click",
  CTA_WHATSAPP: "cta_whatsapp_click",
  CTA_CONTACTO: "cta_contacto_click",
};
